import { HomePageCard } from "./HomePageCard";

import { Contact } from "./Contact";

export const HomeMainSections = () => {
    const cardElements = {
        dave: {
            navLink: "/davesday",
            imageName: "/images/dave-thumb.jpg",
            cardTitle: "How Did Dave's Day Go?",
            cardText:
                "Simulate Dave's ordinary day. Originally written on the basis where a lot goes on in the background but all you get to find out is if Dave had a good day or bad day. What stresses him out?",
            badge: "Dave's Day",
        },

        rightNote: {
            navLink: "/hittingtherightnote",
            imageName: "/images/rightnote-thumb.jpg",
            cardTitle: "Hitting the Right Note",
            cardText:
                "In 2024 I had the honour of joining a study into gender bias in the music industry. These are the resulting 30 second tracks that I produced for the study.",
            badge: "Hitting the Right Note study",
        },

        diffrentia: {
            navLink: "/diffrentia",
            imageName: "/images/diffrentia-thumb.jpg",
            cardTitle: "Diffrentia",
            cardText:
                "Diffrentia is a card game available for Android on the Google Play store. Play through short, addictive games, and battle for your chosen clan over weekly battles.",
            badge: "Diffrentia",
        },

        about: {
            navLink: "/about",
            imageName: "/images/about-thumb.jpg",
            cardTitle: "About Dragonshifty Studios",
            cardText:
                "All about Dragonshifty Studios. With some more info on the elements of the site.",
            badge: "About Dragonshifty Studios",
        },
    };

    return (
        <>
            <section className="">
                <div className="container pt-5 pb-4">
                    <div className="row pt-4 pb-3">
                        <HomePageCard
                            navLink={cardElements.dave.navLink}
                            imageName={cardElements.dave.imageName}
                            cardTitle={cardElements.dave.cardTitle}
                            cardText={cardElements.dave.cardText}
                            badge={cardElements.dave.badge}
                        />
                        <HomePageCard
                            navLink={cardElements.rightNote.navLink}
                            imageName={cardElements.rightNote.imageName}
                            cardTitle={cardElements.rightNote.cardTitle}
                            cardText={cardElements.rightNote.cardText}
                            badge={cardElements.rightNote.badge}
                        />
                        <HomePageCard
                            navLink={cardElements.diffrentia.navLink}
                            imageName={cardElements.diffrentia.imageName}
                            cardTitle={cardElements.diffrentia.cardTitle}
                            cardText={cardElements.diffrentia.cardText}
                            badge={cardElements.diffrentia.badge}
                        />
                        <HomePageCard
                            navLink={cardElements.about.navLink}
                            imageName={cardElements.about.imageName}
                            cardTitle={cardElements.about.cardTitle}
                            cardText={cardElements.about.cardText}
                            badge={cardElements.about.badge}
                        />
                    </div>
                </div>
            </section>
            <Contact />
        </>
    );
};
